import { gql } from '@apollo/client'
import { CHATBOT_SETTINGS_FIELDS } from './fragments/chatbot_settings'

export const CHATBOT_SETTINGS = gql`
  ${CHATBOT_SETTINGS_FIELDS}
  query chatbotSettings {
    chatbotSettings {
      ...ChatbotSettingsFields
    }
  }
`
